import { css } from "@emotion/react";

export const AppStyles = css`
  html,
  body,
  #app {
    height: 100%;
    width: 100%;
  }
  #root {
    height: 100%;
  }
`;
